import axios from 'axios';
import {getCookie} from './helpers';

// Isolated from the portal interceptors. Never log or propagate Axios errors,
// which contain credentials, request configuration and response bodies.
const customerApi = axios.create();

export async function createImpersonation(userId, apiBaseUrl) {
    try {
        const response = await customerApi.post(
            `${apiBaseUrl}/admin/users/${encodeURIComponent(userId)}/impersonation`,
            null,
            {headers: {Authorization: `Bearer ${getCookie('fl_admin_access_token')}`}}
        );
        if (response.status !== 201 || response.data?.success !== true ||
            !/^[a-f0-9]{64}$/.test(response.data?.code)) {
            return {error: 'Could not start the user view. Please try again.'};
        }
        return {code: response.data.code, expiresAt: response.data.code_expires_at};
    } catch (error) {
        const status = error.response?.status;
        let text = status === 403 ? 'You need both admin and impersonate_users roles to view the app as a user.' :
            status === 404 ? 'This user is unavailable for viewing.' :
                error.response?.data?.message || 'Could not start the user view. Check your connection and try again.';
        // Backend messages are displayed only, and sensitive values are redacted.
        text = String(text).replace(/https?:\/\/\S+/g, '[URL removed]')
            .replace(/\b[a-f0-9]{64}\b/g, '[code removed]');
        const token = getCookie('fl_admin_access_token');
        if (token) text = text.split(token).join('[credential removed]');
        return {error: text};
    }
}
